import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Card, CardContent, CardHeader, useTheme } from "@mui/material";
import { ChatbotHeader } from "./ChatbotHeader";
import Conversation from "Components/Common/Conversation";
import {
  useConversationQuery,
  usePostQuestionAnswerMutation,
} from "apis/Chatbot";

const systemId = localStorage.getItem("deviceToken");

export const ChatBotContent = ({ chatBotBtnHandler }) => {
  const theme = useTheme();

  const {
    data: { data: conversationData } = {},
    isLoading,
    isFetching,
  } = useConversationQuery(systemId);

  const [addConversation, { isLoading: isAddingConversation }] =
    usePostQuestionAnswerMutation();

  const responseMessage = useMemo(
    () =>
      conversationData?.reduce((acc, item) => {
        if (item.answer) {
          return [
            ...acc,
            {
              adminMessage: item.question,
            },
            {
              clientMessage: item.answer,
            },
          ];
        }
        return [
          ...acc,
          {
            adminMessage: item.question,
            options: item.options,
            questionId: item.questionId,
          },
        ];
      }, []) || [],
    [conversationData]
  );

  const handleOptionSelect = async (questionId, optionId) => {
    try {
      await addConversation(
        questionId,
        {},
        {
          optionId,
          systemId,
        }
      );
    } catch (error) {}
  };

  return (
    <Card sx={{ maxWidth: "400px", height: "600px" }}>
      <CardHeader
        sx={{
          bgcolor: theme.palette.primary.main,
          height: 60,
        }}
        title={
          <ChatbotHeader
            chatBotBtnHandler={chatBotBtnHandler}
            conversationLength={responseMessage.length}
          />
        }
      />
      <CardContent
        sx={{
          height: "calc(100% - 60px)",
          overflow: "scroll",
        }}
      >
        <Conversation
          conversationResponses={responseMessage}
          isLoading={isLoading || isFetching || isAddingConversation}
          handleSelect={handleOptionSelect}
        />
      </CardContent>
    </Card>
  );
};

ChatBotContent.propTypes = {
  chatBotBtnHandler: PropTypes.func,
};
